import { tsValidateValue } from '@nu-art/ts-common';
import { smartDocParamCondition_DispositionType, smartDocParamCondition_WorkingDiagnosis } from './types.js';
export const Validator_SmartDocParamCondition_WorkingDiagnosis = tsValidateValue([...smartDocParamCondition_WorkingDiagnosis]);
export const Validator_SmartDocParamCondition_DispositionType = tsValidateValue([...smartDocParamCondition_DispositionType]);
//# sourceMappingURL=validation.js.map